import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Page from './page';
import Header from './header';
import Sidebar from './sidebar';
import Content from './content';
import ContentHeader from './content-header';

import Main from './main';
import SelectGroup from 'containers/elements/@commons/select-bank-acc-groups';
import authentication from 'utils/authentication';
import { useAppDispatch, useAppSelector } from 'src/redux/store';
import { selectCompaniesActions, selectCurrencyActions } from 'src/redux/actions';

import styles from './styles.scss';
import { Button } from 'components/index';
import BankIntegrationsModal from 'containers/elements/bank-integrations';

const Layout = ({ children }) => {
  const isSession = authentication.hasSession();
  const history = useHistory();
  const location = useLocation();
  const [isBankIntegrationsOpen, setIsBankIntegrationsOpen] = React.useState(false);
  const bankIntegrationsTriggerRef = React.useRef(null);

  const dispatch = useAppDispatch();

  const {
    theme: { theme },
    selectGroups: { selectedBankAccountGroups },
    selectCompanies: { selectedCompaniesInitialized, selectedVkn },
  } = useAppSelector((state) => state);

  useEffect(() => {
    if (isSession && !selectedCompaniesInitialized) {
      dispatch(selectCompaniesActions.initialize());
    }
  }, [isSession]);

  useEffect(() => {
    if (selectedVkn === null) return;
    if (isSession) {
      dispatch(selectCurrencyActions.initializeCurrencies({ selectedVkn, selectedBankAccountGroups }));
    }
  }, [isSession, selectedVkn, selectedBankAccountGroups]);

  useEffect(() => {
    if (!isSession) return;

    const shouldOpenFromRoute = Boolean(location.state && location.state.openBankIntegrations);
    if (!shouldOpenFromRoute) return;

    setIsBankIntegrationsOpen(true);

    const nextState = { ...location.state };
    delete nextState.openBankIntegrations;
    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: Object.keys(nextState).length > 0 ? nextState : undefined,
    });
  }, [history, isSession, location.hash, location.key, location.pathname, location.search, location.state]);

  if (!isSession) {
    return children;
  }

  const openBankIntegrations = (triggerElement) => {
    bankIntegrationsTriggerRef.current = triggerElement || null;
    setIsBankIntegrationsOpen(true);
  };

  return (
    <Page>
      <Header isBankIntegrationsOpen={isBankIntegrationsOpen} onOpenBankIntegrations={openBankIntegrations} />
      <ContentHeader />
      <Content>
        <div className={styles.sidebar}>
          <div style={{ marginBottom: '10px' }}>
            <SelectGroup />
          </div>
          <Sidebar isBankIntegrationsOpen={isBankIntegrationsOpen} onOpenBankIntegrations={openBankIntegrations} />
        </div>

        <Main>{children}</Main>
        <Button
          style={{ position: 'fixed', bottom: '30px', right: '30px' }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>
          <i className={'icon-icon-navigation-expand-less-24-px'} />
        </Button>
      </Content>
      {isBankIntegrationsOpen && (
        <BankIntegrationsModal
          onClose={() => setIsBankIntegrationsOpen(false)}
          returnFocusRef={bankIntegrationsTriggerRef}
          theme={theme}
        />
      )}
    </Page>
  );
};

export default Layout;
